import { DEFAULT_ICON_PROPS, IIconProps } from './constants';

export const PinIcon = ({
  ariaLabel = 'Pin',
  isHollow = false,
  ...props
}: IIconProps & { isHollow?: boolean }) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...{ width: 13, height: 13 },
    ...props,
  };
  return (
    <svg
      width={size ?? width}
      height={size ?? height}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      {isHollow ? (
        <>
          <path
            d="M11.375 5.41675C11.375 9.20841 6.5 12.4584 6.5 12.4584C6.5 12.4584 1.625 9.20841 1.625 5.41675C1.625 4.12382 2.13861 2.88384 3.05285 1.9696C3.96709 1.05536 5.20707 0.541748 6.5 0.541748C7.79293 0.541748 9.03291 1.05536 9.94715 1.9696C10.8614 2.88384 11.375 4.12382 11.375 5.41675Z"
            stroke="currentcolor"
          />
          <path
            d="M6.5 7.04175C7.39746 7.04175 8.125 6.31421 8.125 5.41675C8.125 4.51929 7.39746 3.79175 6.5 3.79175C5.60254 3.79175 4.875 4.51929 4.875 5.41675C4.875 6.31421 5.60254 7.04175 6.5 7.04175Z"
            stroke="currentcolor"
          />
        </>
      ) : (
        <>
          <path
            d="M11.375 5.41675C11.375 9.20841 6.5 12.4584 6.5 12.4584C6.5 12.4584 1.625 9.20841 1.625 5.41675C1.625 4.12382 2.13861 2.88384 3.05285 1.9696C3.96709 1.05536 5.20707 0.541748 6.5 0.541748C7.79293 0.541748 9.03291 1.05536 9.94715 1.9696C10.8614 2.88384 11.375 4.12382 11.375 5.41675Z"
            fill="currentcolor"
          />
          <path
            d="M6.5 7.04175C7.39746 7.04175 8.125 6.31421 8.125 5.41675C8.125 4.51929 7.39746 3.79175 6.5 3.79175C5.60254 3.79175 4.875 4.51929 4.875 5.41675C4.875 6.31421 5.60254 7.04175 6.5 7.04175Z"
            fill="#FFFFFF"
          />
          <path
            d="M6.5 7.04175C7.39746 7.04175 8.125 6.31421 8.125 5.41675C8.125 4.51929 7.39746 3.79175 6.5 3.79175C5.60254 3.79175 4.875 4.51929 4.875 5.41675C4.875 6.31421 5.60254 7.04175 6.5 7.04175Z"
            stroke="#FFFFFF"
            strokeWidth={0.5}
          />
        </>
      )}
    </svg>
  );
};
